<template>
  <div>
    <v-tooltip bottom v-if="!isSupported">
      <template v-slot:activator="{ on }">
        <v-icon large color="orange" v-on="on" class="unsupported">mdi-alert</v-icon>
      </template>
      <div>{{ $t('sipua.error.notSupported').split('.')[0] }}.</div>
      <div>{{ $t('sipua.error.notSupported').split('.')[1] }}.</div>
    </v-tooltip>
    <div class="sipua-client-btn">
      <v-tooltip bottom v-if="isSupported">
        <template v-slot:activator="{ on }">
          <v-badge offset-x="16" offset-y="16" :value="showMissedCalls && missedCalls" :content="missedCalls" color="orange">
            <v-btn icon v-on="on" :color="color" class="ua-btn mt-1" large
              @click.stop="show=true">
              <v-icon>mdi-{{ icon }}</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>{{ statusText }}</span>
      </v-tooltip>
      <ActiveCalls />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SIPUA from '@/sipua/SIPUA'
import ActiveCalls from '@/components/active_calls/index.vue'

export default {
  name: 'sipua-client',
  data () {
    return {
      isSupported: true
    }
  },
  components: { ActiveCalls },
  mounted () {
    this.isSupported = SIPUA.isWebRTCSupported()
  },
  computed: {
    ...mapGetters({
      sipuaStatus: 'sipuaStatus',
      phoneShow: 'phoneShow',
      missedCalls: 'missedCalls',
      showMissedCalls: 'settings/showMissedCalls',
      sipuaSess: 'sipuaSess'
    }),
    show: {
      get: function () {
        return this.phoneShow
      },
      set: function (val) {
        this.setSIPUAPhoneDisplay(val)
        this.installCallHandler()
      }
    },
    icon: function () {
      if (this.sipuaSess.length > 0) {
        return 'phone-in-talk'
      }
      return SIPUA.isConnected(this.sipuaStatus) ? 'phone' : 'phone-lock'
    },
    color: function () {
      if (SIPUA.isRegistered(this.sipuaStatus)) {
        return 'green darken-1'
      } else if (SIPUA.isConnected(this.sipuaStatus)) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    statusText: function () {
      if (this.sipuaSess.length > 0) {
        return 'On call'
      }
      return SIPUA.isRegistered(this.sipuaStatus)
        ? this.$t('tb.sipua.online')
        : this.$t('tb.sipua.offline')
    },
    btnText: function () {
      if (this.sipuaSess.length > 0) {
        return 'ON CALL'
      }
      return SIPUA.isRegistered(this.sipuaStatus)
        ? 'ONLINE'
        : 'OFFLINE'
    }
  },
  methods: {
    ...mapActions({
      setSIPUAPhoneDisplay: 'setSIPUAPhoneDisplay',
      installCallHandler: 'installCallHandler'
    })
  }
}
</script>

<style scoped>
</style>
